"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dateFns = require("date-fns");
var _DateInput = _interopRequireDefault(require("../../components/date-input/DateInput"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DATE_OF_BIRTH = {
  component: _DateInput["default"],
  id: 'dateOfBirth',
  name: 'dateOfBirth',
  label: 'Date of birth',
  dateFormat: 'YYYY-MM-DD',
  datePresentationFormat: 'DD/MM/YYYY',
  maxDate: (0, _dateFns.format)(new Date(), 'YYYY-MM-DD'),
  minDate: (0, _dateFns.format)((0, _dateFns.subYears)(new Date(), 150), 'YYYY-MM-DD'),
  validationMessageKeys: {
    dateFormat: 'Please enter a valid date',
    minDate: 'Please enter a date after ${minDate}',
    maxDate: 'Please enter a date before ${maxDate}'
  }
};
var _default = exports["default"] = DATE_OF_BIRTH;